import { getAlertTranslationKey } from "@msuite/utils/alerts";
import type { Enums } from "@msuite/utils/types";
import { AlertIcon } from "../icons";
import { useTranslation } from "../localization";

/** Props Interface */
interface AlertLabelProps {
	level: Enums<"alertLevelType">;
}

export function AlertLabel({ level }: AlertLabelProps) {
	const { t } = useTranslation();

	/** Render */
	return (
		<div className="h-stack">
			<AlertIcon variant={level} />
			<p>{t(getAlertTranslationKey(level))}</p>
		</div>
	);
}
